<script setup>
import { defineModel } from "vue";
const visible = defineModel()

import { useRouting } from "@/composables/routing.js";
const { page, href } = useRouting();

const login = () => {
    window.location = page.props.loginUrl;
}

const register = () => {
    window.location = page.props.registrationUrl;
}
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <div >
        <Drawer v-model:visible="visible">
            <template #container="{ closeCallback }">
                <div class="flex flex-col h-full">
                    <div class="flex items-center justify-between px-6 pt-4 shrink-0 mb-10">
                        <Link class="text-lg font-bold mr-8 no-underline"
                              :href="href('/')"
                        >
                            <img src="/assets/logo-500-100.png" alt="LAY7 cloud" class="h-auto w-full">
                        </Link>
                        <span>
                            <Button type="button" @click="closeCallback" icon="pi pi-times" rounded outlined></Button>
                        </span>
                    </div>
                    <div class="overflow-y-auto">
                        <ul class="list-none p-4 m-0 mt-4">
                            <li>
                                <ul class="list-none p-0 m-0 overflow-hidden">
                                    <li>
                                        <Link tag="a"
                                              class="flex items-center cursor-pointer p-4 rounded text-surface-700 hover:bg-surface-100 duration-150 transition-colors p-ripple"
                                              :href="href('/')"
                                        >
                                            <span class="font-medium">
                                                {{ $t("Home") }}
                                            </span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link v-ripple
                                                     tag="a"
                                                     class="flex items-center cursor-pointer p-4 rounded text-surface-700 hover:bg-surface-100 duration-150 transition-colors p-ripple"
                                                     :href="href('/solutions')"
                                        >
                                            <span class="font-medium">
                                                {{ $t("Solutions") }}
                                            </span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link v-ripple
                                                     tag="a"
                                                     class="flex items-center cursor-pointer p-4 rounded text-surface-700 hover:bg-surface-100 duration-150 transition-colors p-ripple"
                                                     :href="href('/features')"
                                        >
                                            <span class="font-medium">
                                                {{ $t("Features") }}
                                            </span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link v-ripple
                                                     tag="a"
                                                     class="flex items-center cursor-pointer p-4 rounded text-surface-700 hover:bg-surface-100 duration-150 transition-colors p-ripple"
                                                     :href="href('/pricing')"
                                        >
                                            <span class="font-medium">
                                                {{ $t("Pricing") }}
                                            </span>
                                        </Link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                    <div class="mt-auto px-5 py-5">
                        <Button severity="secondary"
                                variant="outlined"
                                size="large"
                                as="a"
                                @click="login"
                                class="w-full mb-5"
                        >
                            Login
                        </Button>

                        <Button class="px-12 lg:px-12 py-12 bg-black text-white text-lg font-bold w-full"
                                size="large"
                                as="a"
                                @click="register"
                                :label="$t('Create account')"
                        ></Button>
                    </div>
                </div>
            </template>
        </Drawer>
    </div>
</template>
